import { ITile } from '../components/Catalog/Catalog.models';
import {
  CatalogKind,
  ICamelComponentDefinition,
  ICamelProcessorDefinition,
  ICitrusComponentDefinition,
  IKameletDefinition,
  KameletKnownAnnotations,
  KameletKnownLabels,
} from '../models';
import { getIconRequest } from '../models/visualization/flows/nodes/resolvers/icon-resolver/getIconRequest';

export const camelComponentToTile = async (componentDef: ICamelComponentDefinition): Promise<ITile> => {
  const { name, title, description, supportLevel, label, provider, version } = componentDef.component;
  const headerTags: string[] = ['Component'];
  const tags: string[] = [];

  if (supportLevel && !componentDef.component.deprecated) {
    headerTags.push(supportLevel);
  } else {
    headerTags.push('Deprecated');
  }
  if (label) {
    tags.push(...label.split(','));
  }
  if (componentDef.component.consumerOnly) {
    tags.push('consumerOnly');
  }
  if (componentDef.component.producerOnly) {
    tags.push('producerOnly');
  }

  const { icon: iconUrl } = await getIconRequest(CatalogKind.Component, name);

  return {
    type: CatalogKind.Component,
    name,
    title,
    description,
    headerTags,
    tags,
    provider,
    version,
    iconUrl,
  };
};

export const camelProcessorToTile = async (processorDef: ICamelProcessorDefinition): Promise<ITile> => {
  const { name, title, description, supportLevel, label, provider } = processorDef.model;
  const headerTags: string[] = ['Processor'];
  const tags = label.split(',');

  if (supportLevel) {
    headerTags.push(supportLevel);
  }

  const { icon: iconUrl } = await getIconRequest(CatalogKind.Processor, name);

  return {
    type: CatalogKind.Processor,
    name,
    title,
    description,
    headerTags,
    tags,
    provider,
    iconUrl,
  };
};

export const camelEntityToTile = async (processorDef: ICamelProcessorDefinition): Promise<ITile> => {
  const entityTile = await camelProcessorToTile(processorDef);
  entityTile.type = CatalogKind.Entity;
  entityTile.headerTags = ['Entity'];

  const { icon: iconUrl } = await getIconRequest(CatalogKind.Entity, entityTile.name);
  entityTile.iconUrl = iconUrl;

  return entityTile;
};

export const kameletToTile = async (kameletDef: IKameletDefinition): Promise<ITile> => {
  const headerTags: string[] = ['Kamelet'];
  if (kameletDef.metadata.annotations?.[KameletKnownAnnotations.SupportLevel]) {
    headerTags.push(kameletDef.metadata.annotations[KameletKnownAnnotations.SupportLevel]);
  }

  const tags: string[] = [];
  if (kameletDef.metadata.labels?.[KameletKnownLabels.Type]) {
    tags.push(kameletDef.metadata.labels[KameletKnownLabels.Type]);
  }

  const version = kameletDef.metadata.annotations?.[KameletKnownAnnotations.CatalogVersion];
  const iconUrl = kameletDef.metadata.annotations?.[KameletKnownAnnotations.Icon];
  const kameletProvider = kameletDef.metadata.annotations?.[KameletKnownAnnotations.Provider];
  const provider = kameletProvider === 'Apache Software Foundation' ? 'Community' : kameletProvider;

  return {
    type: CatalogKind.Kamelet,
    name: kameletDef.metadata.name,
    title: kameletDef.spec.definition.title,
    description: kameletDef.spec.definition.description,
    headerTags,
    tags,
    provider,
    version,
    iconUrl,
  };
};

export const citrusComponentToTile = async (componentDefinition: ICitrusComponentDefinition): Promise<ITile> => {
  const { kind, version, name, title, description } = componentDefinition;

  const headerTags: string[] = [kind];
  const tags: string[] = [];

  const { icon: iconUrl } = await getIconRequest(kind, name);

  return {
    type: kind,
    name: name,
    title: title || name,
    description: description,
    headerTags,
    tags,
    version,
    iconUrl,
  };
};
